import React from 'react';
const BRAND_LOGOS = [{
  name: 'Aspen Laser',
  src: 'https://cdn.magicpatterns.com/uploads/6sJBBBVY5X5SwQxubyZT8d/aspen-laser-logo-tight.png',
  tone: 'light',
  width: 'w-[136px]'
}, {
  name: 'Multi Radiance Medical',
  src: 'https://cdn.magicpatterns.com/uploads/1uSvh2c4GvcPaou7cFZQiv/multi-radiance-logo-tight.png',
  tone: 'dark',
  width: 'w-[140px]'
}, {
  name: 'AWUSA',
  src: 'https://cdn.magicpatterns.com/uploads/vU7ymN9woCWqfMQ7Z1BUMg/awusa-acoustic-wave-logo-tight.png',
  tone: 'dark',
  label: 'AWUSA',
  width: 'w-[140px]'
}, {
  name: 'LumaNova',
  src: 'https://cdn.magicpatterns.com/uploads/cGAUHMWRd116qzuguyqeC6/lumanova-logo.svg',
  tone: 'dark',
  width: 'w-[140px]'
}, {
  name: 'TheraLight',
  src: 'https://cdn.magicpatterns.com/uploads/vttP1Sb7gikoGaFWY35ZNt/theralight-logo-tight.png',
  tone: 'light',
  width: 'w-[132px]'
}, {
  name: 'ThermoVision',
  src: 'https://cdn.magicpatterns.com/uploads/pwi9F6MQ1aEKhfXdZzRCNm/thermovision-myovision-logo.png',
  tone: 'light',
  label: 'ThermoVision',
  width: 'w-[140px]'
}, {
  name: 'WellVu',
  src: 'https://cdn.magicpatterns.com/uploads/qMimGwm5vM6HRxKcW7oosi/wellvu-logo.png',
  tone: 'light',
  width: 'w-[120px]'
}, {
  name: 'Hivamat',
  src: 'https://cdn.magicpatterns.com/uploads/vNnD1dHYLjEaEQqbPKyjtJ/hivamat-logo-tight.png',
  tone: 'dark',
  width: 'w-[132px]'
}, {
  name: 'Endopuls',
  src: 'https://cdn.magicpatterns.com/uploads/2VZTmXjs9iTkUtkfftmxFG/endopuls-enraf-logo.png',
  tone: 'light',
  label: 'Endopuls',
  width: 'w-[128px]'
}] as const;
export function ManufacturerStrip() {
  return <section className="w-full overflow-hidden border-y border-slate-200 bg-slate-50/90" data-id="element-210" data-mp="3bvrawx9jnvub">
      <div className="mx-auto max-w-7xl px-5 py-7 sm:px-8" data-id="element-211" data-mp="3gx8bero49gad">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-charcoal/55" data-id="element-212" data-mp="3lv9tpadpxbks">
          CURATED TECHNOLOGIES FROM TRUSTED MODALITY BRANDS
        </p>
        <ul className="mt-4 flex flex-wrap justify-center gap-2.5" aria-label="Trusted modality brands" data-id="element-213" data-mp="2w50cm1l5l89w">
          {BRAND_LOGOS.map(brand => {
          const isDark = brand.tone === 'dark';
          return <li key={brand.name} className={`flex shrink-0 flex-col items-center justify-center rounded-xl border px-2.5 shadow-[0_2px_8px_-4px_rgba(26,27,75,0.28)] ${brand.width} ${brand.label ? 'h-16 gap-1' : 'h-14'} ${isDark ? 'border-teal/30 bg-navy' : 'border-slate-200 bg-white'}`} data-id="element-214" data-mp="3167ke0naq7gk">
                <img src={brand.src} alt={`${brand.name} logo`} className="max-h-[34px] max-w-[120px] object-contain" data-id="element-215" data-mp="3ouqsog6cik8n" />
                {brand.label && <span className={`text-[9px] font-bold uppercase tracking-[0.12em] ${isDark ? 'text-white/85' : 'text-navy/70'}`} data-id="element-216" data-mp="1ui0yryfz9b19">
                    {brand.label}
                  </span>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}